import { VideoElement } from './Element';
import { VideoOverlayer } from './Overlayer';
import { VideoPlayerWindow } from './Player';

export default {
  setup({ app }) {
    app.extension.registerElement('video', {
      element: VideoElement,
      overlayer: VideoOverlayer,
    });

    app.extension.registerComponent('root', { Component: VideoPlayerWindow });
  },
};
